module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/id/4-784b365b2363c73f70f1dc8102aa38ff.jpg";